export {default} from '../../../core/components/Repository/LabelText';